import { useState } from "react";
import Body from "../components/Body/Body";
import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";

const Home = () => {
  const [count, setCount] = useState(0);
  return (
    <>
      <Header id="windowclose" count={count} setCount={setCount} />
      <Body count={count} setCount={setCount} />
      <Footer />
    </>
  );
};

export default Home;
